import { actionTypes } from '../constants/actionTypes';

export const customerLogoUrl = customerLogo => ({
  type: actionTypes.CUSTOMER_LOGO_URL,
  payload: customerLogo
});

export const customerId = customerIdValue => ({
  type: actionTypes.CUSTOMER_ID,
  payload: customerIdValue
});

export const activityMenu = menu => ({
  type: actionTypes.ACTIVITY_MENU,
  payload: menu
});

export const authToken = token => ({
  type: actionTypes.SET_AUTH_TOKEN,
  payload: token
});

export const displayLoader = display => ({
  type: actionTypes.DISPLAY_LOADER,
  payload: display
});

export const sideNavContent = data => ({
  type: actionTypes.SIDE_NAV_CONTENT,
  payload: data
});

export const infoMessage = info => ({
  type: actionTypes.INFO_MESSAGE,
  payload: info
});

export const displayMessage = display => ({
  type: actionTypes.DISPLAY_MESSAGE,
  payload: display
});

export const pairCode = code => ({
  type: actionTypes.PAIR_CODE,
  payload: code
});

export const mobileDevices = devices => ({
  type: actionTypes.MOBILE_DEVICES,
  payload: devices
});

// Translations Action Creators
export function translations(translationsData) {
  return {
    type: actionTypes.UPDATE_TRANSLATIONS,
    translationsData
  };
}

export function updatePrivacyPolicyLink(link) {
  return {
    type: actionTypes.UPDATE_PRIVACY_POLICY_LINK,
    link
  };
}

export function changeLocale(locale) {
  return {
    type: actionTypes.UPDATE_LANGUAGE_LOCALE,
    locale
  };
}

export const cartLink = link => ({
  type: actionTypes.CART_LINK,
  payload: link
});

export const catalogPoints = points => ({
  type: actionTypes.CATALOG_POINTS,
  payload: points
});

export const catalogSymbol = symbol => ({
  type: actionTypes.CATALOG_SYMBOL,
  payload: symbol
});

export const catalogLink = link => ({
  type: actionTypes.CATALOG_LINK,
  payload: link
});


export const banks = list => ({
  type: actionTypes.BANKS,
  payload: list
});


export const banksCatalog = list => ({
  type: actionTypes.BANKS_CATALOG,
  payload: list
});

export const awards = list => ({
  type: actionTypes.AWARDS,
  payload: list
});

export const catalogs = logs => ({
  type: actionTypes.CATALOGS,
  payload: logs
});

export const footerLinks = links => ({
  type: actionTypes.FOOTERLINKS,
  payload: links
});

export const clientColors = colors => ({
  type: actionTypes.CLIENT_COLORS,
  payload: colors
});

export const greeting = text => ({
  type: actionTypes.GREETING,
  payload: text
});

export const alertsCount = count => ({
  type: actionTypes.ALERTS_COUNT,
  payload: count
});

export const genericAlerts = alerts => ({
  type: actionTypes.GENERIC_ALERTS,
  payload: alerts
});

export const receiveAlerts = alerts => ({
  type: actionTypes.RECEIVE_ALERTS,
  payload: alerts
});

export const bankAccountFilters = filters => ({
  type: actionTypes.BANK_ACCOUNT_FILTERS,
  payload: filters
});

export const tabSelected = index => ({
  type: actionTypes.SELECT_TAB,
  payload: index
});

export const bankAccountTransactions = transactions => ({
  type: actionTypes.BANK_ACCOUNT_TRANSACTIONS,
  payload: transactions
});

export const pagination = bankPagination => ({
  type: actionTypes.BANK_ACCOUNT_PAGINATION,
  payload: bankPagination
});

export const viewsPerPage = count => ({
  type: actionTypes.SET_PAGE_VEIW_SIZE,
  payload: count
});

export const availableAccessCodeCount = count => ({
  type: actionTypes.AVAILABLE_ACCESS_CODE_COUNT,
  payload: count
});

export const eventsNumber = numbers => ({
  type: actionTypes.PAGE_VIEW_NUMBERS,
  payload: numbers
});

export const displayNoBankTransactions = display => ({
  type: actionTypes.DISPLAY_NO_BANK_TRANSACTIONS,
  payload: display
});

export const activeBankId = bankId => ({
  type: actionTypes.ACTIVE_BANK_ID,
  payload: bankId
});

export const overviewHistoryReceived = received => ({
  type: actionTypes.OVERVIEW_HISTORY_RECEIVED,
  payload: received
});

export const overviewHistorySent = sent => ({
  type: actionTypes.OVERVIEW_HISTORY_SENT,
  payload: sent
});

export const overviewBankSummary = bank => ({
  type: actionTypes.OVERVIEW_BANK_SUMMARY,
  payload: bank
});

export const overviewRecentOrders = orders => ({
  type: actionTypes.OVERVIEW_RECENT_ORDERS,
  payload: orders
});

export const overviewSkillsFinder = skills => ({
  type: actionTypes.OVERVIEW_SKILLS_FINDER,
  payload: skills
});

export const overviewAlerts = alerts => ({
  type: actionTypes.OVERVIEW_ALERTS,
  payload: alerts
});

export const bankNameSelected = name => ({
  type: actionTypes.SELECT_BANK,
  payload: name
});

export const ordersFilters = filters => ({
  type: actionTypes.ORDER_FILTERS,
  payload: filters
});

export const printUrl = url => ({
  type: actionTypes.PRINT_URL,
  payload: url
});

export const isDisplayReceivedActions = display => ({
  type: actionTypes.IS_DISPLAY_RECEIVED_ACTIONS,
  payload: display
});

export const ordersList = orders => ({
  type: actionTypes.ORDERS,
  payload: orders
});

export const ordersPagination = ordersPaginationValue => ({
  type: actionTypes.ORDERS_PAGINATION,
  payload: ordersPaginationValue
});

export const ordersViewsPerPage = count => ({
  type: actionTypes.SET_ORDERS_PAGE_VEIW_SIZE,
  payload: count
});

export const ordersEventsNumber = numbers => ({
  type: actionTypes.ORDERS_PAGE_VIEW_NUMBERS,
  payload: numbers
});

export const isDisplayeCardDialogActions = display => ({
  type: actionTypes.IS_DISPLAY_ECARD_DIALOG_ACTIONS,
  payload: display
});

export const isDisplayNominationDialogActions = display => ({
  type: actionTypes.IS_DISPLAY_NOMINATION_DIALOG_ACTIONS,
  payload: display
});

export const nominationActivityValues = data => ({
  type: actionTypes.NOMINATION_ACTIVITY_VALUES,
  payload: data
});

export const ecardActivityValues = data => ({
  type: actionTypes.ECARD_ACTIVITY_VALUES,
  payload: data
});

export const personalInfoValues = data => ({
  type: actionTypes.PERSONAL_INFO_VALUES,
  payload: data
});

export const awardDetailValues = data => ({
  type: actionTypes.AWARD_DETAIL_VALUES,
  payload: data
});

export const orderDetailValues = data => ({
  type: actionTypes.ORDER_DETAIL_VALUES,
  payload: data
});


export const programsDropdownOpen = open => ({
  type: actionTypes.PROGRAMS_DROPDOWN_OPEN,
  payload: open
});

export const ordersSearchDisplay = display => ({
  type: actionTypes.ORDERS_SEARCH_DISPLAY,
  payload: display
});

export const ordersSearchData = data => ({
  type: actionTypes.ORDERS_SEARCH_DATA,
  payload: data
});

export const downloadDropdownOpen = open => ({
  type: actionTypes.DOWNLOAD_DROPDOWN_OPEN,
  payload: open
});

export const isDisplayBankDialogActions = display => ({
  type: actionTypes.IS_DISPLAY_BANK_DIALOG_ACTIONS,
  payload: display
});

export const isDisplayBankDetailsLink= display => ({
  type: actionTypes.IS_DISPLAY_BANK_DETAILS_LINK,
  payload: display
});

export const bankDetailValues = data => ({
  type: actionTypes.BANK_DETAIL_VALUES,
  payload: data
});

export const isDisplayProgramDialogActions = display => ({
  type: actionTypes.IS_DISPLAY_PROGRAM_DIALOG_ACTIONS,
  payload: display
});

export const programDetailValues = data => ({
  type: actionTypes.PROGRAM_DETAIL_VALUES,
  payload: data
});

export const isDisplayAlertsSection= display => ({
  type: actionTypes.IS_DISPLAY_ALERTS_SECTION,
  payload: display
});

export const isDisplaySkillsSection= display => ({
  type: actionTypes.IS_DISPLAY_SKILLS_SECTION,
  payload: display
});

export const isDisplayDetailsAlerts= display => ({
  type: actionTypes.IS_DISPLAY_DETAILS_ALERTS,
  payload: display
});

export const preferredLocale= locale => ({
  type: actionTypes.PREFFERED_LANGUAGE_LOCALE,
  payload: locale
});

export const locale = val => ({
  type: actionTypes.SET_LOCALE,
  payload: val
});

export const hasGivenWidgetEnabled= display => ({
  type: actionTypes.HAS_WIDGET_ENABLED,
  payload: display
});

export const isDisplayMessageDialog = display => ({
  type: actionTypes.IS_DISPLAY_MESSAGE_DIALOG,
  payload: display
});

export const permissionDisplayItems = data => ({
  type: actionTypes.PERMISSON_DISPLAY_ITEMS,
  payload: data
});

export const orderSearch = data => ({
  type: actionTypes.ORDER_SEARCH,
  payload: data
});

export const orderSearchPrograms = data => ({
  type: actionTypes.ORDER_SEARCH_PROGRAMS,
  payload: data
});

export const searchOrdersList = data => ({
  type: actionTypes.SEARCH_ORDERS_LIST,
  payload: data
});

export const recentRangeList = data => ({
  type: actionTypes.RECENT_RANGE_LIST,
  payload: data
});

export const isRangeDropdownOpen = isOpen => ({
  type: actionTypes.IS_RANGE_DROPDOWN_OPEN,
  payload: isOpen
});

export const selectedRange = data => ({
  type: actionTypes.SELECTED_RANGE,
  payload: data
});

export const recentOrdersList = data => ({
  type: actionTypes.RECENT_ORDERS_LIST,
  payload: data
});

export const isDisplayRedeemLink= display => ({
  type: actionTypes.IS_DISPLAY_REDEEM_LINK,
  payload: display
});

export const customerDateFormat = dateFormat => ({
  type: actionTypes.CUSTOMER_DATE_FORMAT,
  payload: dateFormat
});

export const activeLanguage = language => ({
  type: actionTypes.ACTIVE_LANGUAGE,
  payload: language
});

export const isDisplaySkillsLoader= display => ({
  type: actionTypes.IS_DISPLAY_SKILLS_LOADER,
  payload: display
});

export const isLoading = display => ({
  type: actionTypes.IS_LOADING,
  payload: display
});

export const displaySessionTimeOut = display => ({
  type: actionTypes.DISPLAY_SESSION_TIMEOUT,
  payload: display
});

export const logoutValue = data => ({
  type: actionTypes.LOGOUT,
  payload: data
});

export const isDisplayAwardPoints= display => ({
  type: actionTypes.IS_DISPLAY_AWARD_POINTS,
  payload: display
});

export const isDisplayReplyLink= display => ({
  type: actionTypes.IS_DISPLAY_REPLY_LINK,
  payload: display
});

export const isDisplaySideBarPanel = display => ({
  type: actionTypes.IS_DISPLAY_SIDEBAR_PANEL,
  payload: display
});

export const avatarLink= data => ({
  type: actionTypes.AVATAR_LINK,
  payload: data
});

export const monthsWeeks = data => ({
  type: actionTypes.MONTHS_WEEKS,
  payload: data
});

export const isBankViewClicked = display => ({
  type: actionTypes.IS_BANK_VIEW_CLICKED,
  payload: display
});

export const tasksCount = count => ({
  type: actionTypes.TASKS_COUNT,
  payload: count
});

export const isDisplayBanksSection= display => ({
  type: actionTypes.IS_DISPLAY_BANKS_SECTION,
  payload: display
});

export const isDisplayOrdersSection= display => ({
  type: actionTypes.IS_DISPLAY_ORDERS_SECTION,
  payload: display
});

export const customerTitle = data => ({
  type: actionTypes.CUSTOMER_TITLE,
  payload: data
});

export const pageDropdownOpen = open => ({
  type: actionTypes.PAGE_DROPDOWN_OPEN,
  payload: open
});

export const selectedDropDownValue = data => ({
  type: actionTypes.SELECTED_DROPDOWN_VALUE,
  payload: data
});

export const isDisplayCommonHeaderSideMenu = display => ({
  type: actionTypes.IS_DISPLAY_COMMON_HEADER_SIDEMENU,
  payload: display
});

export const isDisplayFromDateCalendar = display => ({
  type: actionTypes.IS_DISPLAY_FROM_CALENDAR,
  payload: display
});

export const isDisplayToDateCalendar = display => ({
  type: actionTypes.IS_DISPLAY_TO_CALENDAR,
  payload: display
});

export const customerSTP = customerStp => ({
  type: actionTypes.CUSTOMER_STP,
  payload: customerStp
});

export const translationsGreatwork = translationsData => ({
  type: actionTypes.TRANSLATIONS_GREATWORK,
  payload: translationsData
});

export const isDisplayBankViewCatalog= display => ({
  type: actionTypes.IS_DISPLAY_BANK_VIEW_CATALOG,
  payload: display
});

export const redeemPrograms = redeemedPrograms => ({
  type: actionTypes.REDEEM_PROGRAMS,
  payload: redeemedPrograms
});

export const manuallyEnteredDate = data => ({
  type: actionTypes.MANUALLY_ENTERED_DATE,
  payload: data
});
